export const AWS_REGION = "us-east-1";
export const AWS_IOT_ENDPOINT = "a26y19amya8n0z-ats.iot.us-east-1.amazonaws.com";
export const AWS_COGNITO_IDENTITY_POOL_ID = "us-east-1:4ae58bcd-82c8-413a-b644-c722021a12c2";
